export default __webpack_public_path__ + "static/media/wordpairs.6c6ba1f1.svg";